(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-editorial-home"] && !Shopify.designMode) return;
  try {
    
/* Version 2 interactions: story switching, pause control, and subtle scroll reveals. */
(function () {
  function initialize(scope) {
    var roots = (scope || document).querySelectorAll('[data-mc-home]');
    roots.forEach(function (root) {
      if (root.dataset.mcInitialized) return;
      root.dataset.mcInitialized = 'true';

      var slides = Array.from(root.querySelectorAll('[data-mc-slide]'));
      var choices = Array.from(root.querySelectorAll('[data-mc-choose]'));
      var pauseButton = root.querySelector('[data-mc-pause]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var current = 0;
      var paused = reducedMotion.matches;
      var timer;

      function show(index) {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.inert = !active;
        });
        choices.forEach(function (choice, i) {
          choice.classList.toggle('is-active', i === current);
          if (choice.tagName === 'BUTTON') choice.setAttribute('aria-pressed', i === current ? 'true' : 'false');
        });
      }

      function schedule() {
        window.clearInterval(timer);
        if (!paused && slides.length > 1 && !document.hidden && !ShopifyEditor()) {
          timer = window.setInterval(function () { show(current + 1); }, 7500);
        }
      }

      function ShopifyEditor() {
        return Boolean(window.Shopify && window.Shopify.designMode);
      }

      choices.forEach(function (choice, i) {
        if (choice.tagName === 'A') {
          choice.addEventListener('mouseenter', function () { show(i); window.clearInterval(timer); });
          choice.addEventListener('mouseleave', schedule);
          choice.addEventListener('focus', function () { show(i); window.clearInterval(timer); });
          choice.addEventListener('blur', schedule);
        } else {
          choice.addEventListener('click', function () { show(i); schedule(); });
        }
      });
      if (pauseButton) {
        pauseButton.addEventListener('click', function () {
          paused = !paused;
          pauseButton.setAttribute('aria-pressed', paused ? 'true' : 'false');
          pauseButton.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
          pauseButton.textContent = paused ? '▶' : 'Ⅱ';
          schedule();
        });
        if (paused) {
          pauseButton.setAttribute('aria-pressed', 'true');
          pauseButton.setAttribute('aria-label', 'Play slideshow');
          pauseButton.textContent = '▶';
        }
      }
      document.addEventListener('visibilitychange', schedule);
      reducedMotion.addEventListener('change', function (event) {
        if (event.matches) { paused = true; if (pauseButton) { pauseButton.setAttribute('aria-pressed', 'true'); pauseButton.setAttribute('aria-label', 'Play slideshow'); pauseButton.textContent = '▶'; } }
        schedule();
      });
      show(0);
      schedule();

      var categoryScroller = root.querySelector('[data-mc-category-scroller]');
      if (categoryScroller) {
        var categoryTrack = categoryScroller.querySelector('[data-mc-category-track]');
        var categoryPrev = categoryScroller.querySelector('[data-mc-category-prev]');
        var categoryNext = categoryScroller.querySelector('[data-mc-category-next]');
        function updateCategoryArrows() {
          var maxScroll = categoryTrack.scrollWidth - categoryTrack.clientWidth;
          var canScroll = maxScroll > 4;
          categoryPrev.hidden = !canScroll;
          categoryNext.hidden = !canScroll;
          categoryPrev.disabled = categoryTrack.scrollLeft <= 4;
          categoryNext.disabled = categoryTrack.scrollLeft >= maxScroll - 4;
        }
        function scrollCategories(direction) {
          var card = categoryTrack.querySelector('.mc-home__category');
          var distance = card ? card.getBoundingClientRect().width : categoryTrack.clientWidth / 9;
          categoryTrack.scrollBy({ left: direction * distance, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        }
        categoryPrev.addEventListener('click', function () { scrollCategories(-1); });
        categoryNext.addEventListener('click', function () { scrollCategories(1); });
        categoryTrack.addEventListener('scroll', updateCategoryArrows, { passive: true });
        window.addEventListener('resize', updateCategoryArrows);
        if ('ResizeObserver' in window) new ResizeObserver(updateCategoryArrows).observe(categoryTrack);
        updateCategoryArrows();
      }

      var reveals = root.querySelectorAll('.mc-reveal');
      if (!reducedMotion.matches && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('mc-in-view');
              observer.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -40px 0px', threshold: 0.04 });
        reveals.forEach(function (element) { observer.observe(element); });
        root.classList.add('mc-motion-ready');
      }
    });
  }

  if (window.MCEditorialHome) {
    window.MCEditorialHome(document);
  } else {
    window.MCEditorialHome = initialize;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initialize(document); });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-floating-promo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialize(scope) {
    (scope || document).querySelectorAll('[data-mc-floating-promo]').forEach(function (promo) {
      if (promo.dataset.mcReady) return;
      promo.dataset.mcReady = '1';

      var close = promo.querySelector('[data-mc-floating-promo-close]');
      if (close) close.addEventListener('click', function () {
        promo.hidden = true;
      });
    });
  }

  if (!window.MCFloatingPromo) {
    window.MCFloatingPromo = initialize;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initialize(document); });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        document.querySelectorAll('[data-mc-floating-promo]').forEach(function (promo) {
          promo.hidden = false;
        });
      }
    });
  } else {
    initialize(document);
  }
}());

  } catch(e) { console.error(e); }
})();
})();
